export default __webpack_public_path__ + "assets/northerncyprus-flag.png";